import axios from 'axios'

export default {
  state: {
    currentPhotoIndex: 0,
    is360Overview: false,
    overview360: null
  },
  mutations: {
    SET_MAIN_PHOTO_INDEX: (state, index) => {
      state.currentPhotoIndex = index
    },
    SET_360_OVERVIEW (state, bool) {
      state.is360Overview = bool
    },
    SET_360_INFO (state, info) {
      state.overview360 = info
    }
  },
  actions: {
    CHANGE_MAIN_PHOTO_INDEX: ({ commit, state }, index) => {
      commit('SET_MAIN_PHOTO_INDEX', index)
      // Скрывает 360 если был выбран слайд в навигационной панели слайдера
      if (state.is360Overview) commit('SET_360_OVERVIEW', false)
    },
    SET_360_OVERVIEW_ACTION ({ commit }, bool) {
      commit('SET_360_OVERVIEW', bool)
    },
    FETCH_360_OVERVIEW ({ commit, rootGetters }, id) {
      // Запрос на получение картинок для 360
      axios
        .get(rootGetters.urlLanguagePrefix + '/shop/catalog/get-360-view-photos/', { params: { product_id: id } })
        .then(response => {
          if (response.data && response.data.success && Object.keys(response.data.photos).length) {
            commit('SET_360_INFO', response.data)
          }
        })
    }
  }
}
